import Injectable from '@/modules/shared/domain/di/injectable';
import { UpdatePhoneRepository } from '../../../domain/repository/update-phone-repository';

@Injectable()
export default class UpdatePhoneDummyRepository implements UpdatePhoneRepository {
  update(): Promise<void> {
    return Promise.resolve();
  }
}
